/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../ui-elements/logo/logo.component.ngfactory';
import * as import2 from '../../ui-elements/logo/logo.component';
import * as import3 from '../../ordering-context/ordering-context.model';
import * as import4 from '../../ui-elements/image/background-image.directive';
import * as import5 from '../../ui-elements/image/cached-image.service';
import * as import6 from '@angular/common';
import * as import7 from './page-header-image.component';
import * as import8 from '../../orchestration/session.model';
const styles_PageHeaderImageComponent:any[] = ([] as any[]);
export const RenderType_PageHeaderImageComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_PageHeaderImageComponent,
  data: {}
}
);
function View_PageHeaderImageComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-logo',[[
        'class',
        'image-page-logo logo'
      ]
    ],(null as any),(null as any),(null as any),import1.View_LogoComponent_0,import1.RenderType_LogoComponent)),
      import0.ɵdid(49152,(null as any),0,import2.LogoComponent,[import3.OrderingContextModel],{type: [
        0,
        'type'
      ]
    },(null as any))
  ]
  ,(ck,v) => {
    const currVal_0:any = 'vertical';
    ck(v,1,0,currVal_0);
  },(null as any));
}
export function View_PageHeaderImageComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'image'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import4.BackgroundImageDirective,[
      import0.ElementRef,
      import0.Renderer2,
      import5.CachedImageService
    ]
      ,{imageSpecs: [
        0,
        'imageSpecs'
      ]
    },(null as any)),
    import0.ɵpod([
      'image',
      'opacity',
      'classes'
    ]
    ),
    import0.ɵpad(1),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PageHeaderImageComponent_1)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import7.PageHeaderImageComponent = v.component;
    const currVal_0:any = ck(v,3,0,ck(v,2,0,co.orderingContextModel.headerImage,co.orderingContextModel.headerImageOpacity,'theme-header-image-color-pair'));
    ck(v,1,0,currVal_0);
    const currVal_1:any = co.showPageLogo;
    ck(v,6,0,currVal_1);
  },(null as any));
}
function View_PageHeaderImageComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-page-header-image',([] as any[]),(null as any),(null as any),(null as any),View_PageHeaderImageComponent_0,RenderType_PageHeaderImageComponent)),
    import0.ɵdid(245760,(null as any),0,import7.PageHeaderImageComponent,[
      import8.SessionModel,
      import3.OrderingContextModel,
      import0.ChangeDetectorRef
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const PageHeaderImageComponentNgFactory:import0.ComponentFactory<import7.PageHeaderImageComponent> = import0.ɵccf('woa-page-header-image',import7.PageHeaderImageComponent,View_PageHeaderImageComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvcGFnZS1sYXlvdXQvcGFnZS1oZWFkZXItaW1hZ2UvcGFnZS1oZWFkZXItaW1hZ2UuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvcGFnZS1sYXlvdXQvcGFnZS1oZWFkZXItaW1hZ2UvcGFnZS1oZWFkZXItaW1hZ2UuY29tcG9uZW50LnRzIiwibmc6Ly8vaG9tZS9ydW5uZXIvd29yay93ZWItb3JkZXJpbmctYXBwL3dlYi1vcmRlcmluZy1hcHAvc3JjL2FwcC9wYWdlLWxheW91dC9wYWdlLWhlYWRlci1pbWFnZS9wYWdlLWhlYWRlci1pbWFnZS5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvcGFnZS1sYXlvdXQvcGFnZS1oZWFkZXItaW1hZ2UvcGFnZS1oZWFkZXItaW1hZ2UuY29tcG9uZW50LnRzLlBhZ2VIZWFkZXJJbWFnZUNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxkaXYgY2xhc3M9XCJpbWFnZVwiXG4gICAgIFt3b2EtYmFja2dyb3VuZC1pbWFnZV09XCJbe1xuICAgICAgICAgaW1hZ2U6IG9yZGVyaW5nQ29udGV4dE1vZGVsLmhlYWRlckltYWdlLFxuICAgICAgICAgb3BhY2l0eTogb3JkZXJpbmdDb250ZXh0TW9kZWwuaGVhZGVySW1hZ2VPcGFjaXR5LFxuICAgICAgICAgY2xhc3NlczogJ3RoZW1lLWhlYWRlci1pbWFnZS1jb2xvci1wYWlyJ1xuICAgICB9XVwiPlxuICAgIDx3b2EtbG9nbyBjbGFzcz1cImltYWdlLXBhZ2UtbG9nb1wiIFt0eXBlXT1cIid2ZXJ0aWNhbCdcIiAqbmdJZj1cInNob3dQYWdlTG9nb1wiPjwvd29hLWxvZ28+XG48L2Rpdj5cbiIsIjx3b2EtcGFnZS1oZWFkZXItaW1hZ2U+PC93b2EtcGFnZS1oZWFkZXItaW1hZ2U+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7TUNNSTtRQUFBO1FBQUE7TUFBQTtJQUFBO2tCQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7OztJQUFrQztJQUFsQyxTQUFrQyxTQUFsQzs7Ozs7TUFOSjtRQUFBO1FBQUE7TUFBQTtJQUFBO2dCQUFBOzs7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO2dCQUNLO01BQUE7TUFBQTtNQUFBO0lBQUE7SUFBQTtnQkFBQTtJQUlJO0lBQ0w7Z0JBQUE7OztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUFzRjtJQUNwRjs7OztJQU5EO0lBREwsU0FDSyxTQURMO0lBTTBEO0lBQXRELFNBQXNELFNBQXREOzs7OztJQ05KO2dCQUFBOzs7O0lBQUE7S0FBQTs7O0lBQUE7OzsifQ==



// WEBPACK FOOTER //
// ./src/app/page-layout/page-header-image/page-header-image.component.ngfactory.ts